





































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ElActivity: () => import('@/components/parts/ElActivity.vue'),
  },
})
export default class Activity extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;
}
